import React from "react"
import { Table, TableBody, TableCell, TableHead, TableRow, TableHeader } from "core/components/v2/Table"
import ProgressMeetFeedbackModal from "./ProgressMeetFeedbackModal"
import SummaryModal from "./SummaryModal"
import ProgressMeetViewModel from "../ProgressMeetViewModel"
import { ProgressMeetFeedback } from "domain/model/ProgressMeet"
import ProgressMeetFeedbackCard from "./ProgressMeetFeedbackCard"
import { Link, useNavigate } from "react-router-dom"
import Spinner from "core/components/Spinner"
interface Session {
  chapter_name: string
  session_timestamp: number
  class_link: string
  summary: string
  meeting_id: string
  batches: string[]
}

interface PastSessionTableProps {
  pastSessions: Session[]
}

const PastSessionTable: React.FC<PastSessionTableProps> = ({ pastSessions }) => {
  const {
    saveProgressMeetFeedback,
    getStudentProgressMeetFeedback,
    studentFeedback,
    isFeedbackCardOpen,
    setIsFeedbackCardOpen,
    openFeedbackModal,
    setOpenFeedbackModal,
    fetchProgressMeetStatus,
    loadingStatuses,
    statusMap,
  } = ProgressMeetViewModel()
  const formatTimestamp = (timestamp: number) => {
    const date = new Date(timestamp * 1000)
    return date.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })
  }

  const [openSummaryModal, setOpenSummaryModal] = React.useState<string | null>(null)

  const [openFeedbackCard, setOpenFeedbackCard] = React.useState<string | null>(null)
  const [submittedFeedback, setSubmittedFeedback] = React.useState<Record<string, any>>({})
  React.useEffect(() => {
    fetchProgressMeetStatus(pastSessions)
  }, [pastSessions])

  const handleFeedbackClick = (meetingId: string) => {
    getStudentProgressMeetFeedback(meetingId)
  }
  const navigate = useNavigate()

  return (
    <>
      <Table className="overflow-hidden rounded w-full  mt-6">
        <TableHeader className="rounded h-[31px]">
          <TableRow className="rounded bg-[#333]">
            <TableHead className="text-xs text-white px-4">Progress Meet</TableHead>
            <TableHead className="text-xs text-white px-1">Status</TableHead>
            <TableHead className="text-xs text-white px-1">Date</TableHead>
            <TableHead className="text-xs text-white px-1">Recording</TableHead>
            <TableHead className="text-xs text-white px-1">Summary</TableHead>
            <TableHead className="text-xs text-white px-1">Feedback</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {pastSessions?.length > 0 ? (
            [...pastSessions]
              .sort((a, b) => b.session_timestamp - a.session_timestamp)
              .map((session, index) => (
                <TableRow key={index} className="px-4 hover:bg-[#ebebeb] h-[31px]">
                  <TableCell className="text-xs px-4 py-2 text-left">{session.chapter_name}</TableCell>
                  <TableCell className="text-xs px-1 py-2 text-left">
                    {loadingStatuses ? (
                      <Spinner xs />
                    ) : statusMap[session.meeting_id] === true ? (
                      <span className="text-success">Present</span>
                    ) : (
                      <span className="text-failure">Absent</span>
                    )}
                  </TableCell>
                  <TableCell className="text-xs px-1 py-2 text-left">
                    {formatTimestamp(session.session_timestamp)}
                  </TableCell>
                  <TableCell className="text-xs px-1 py-2 text-right">
                    <button
                      className="flex cursor-pointer items-center justify-center rounded-[4px] bg-white py-[5px] text-[12px] font-medium leading-[15px] text-[#646464] hover:bg-[#EBEBEB] border-[0.5px] border-[#d3d3d3] w-[85px] h-[25px]"
                      onClick={() => {
                        navigate(`${session?.meeting_id}`)
                      }}
                    >
                      Play Rec.
                    </button>
                  </TableCell>
                  <TableCell className="text-xs px-1 py-2 text-right">
                    <button
                      className="flex cursor-pointer items-center justify-center rounded-[4px] bg-white py-[5px] px-4 text-[12px] font-medium leading-[15px] text-[#646464] hover:bg-[#EBEBEB] border-[0.5px] border-[#d3d3d3] w-[85px] h-[25px]"
                      onClick={() => setOpenSummaryModal(session.chapter_name)}
                    >
                      Summary
                    </button>
                    <SummaryModal
                      isOpen={openSummaryModal === session.chapter_name}
                      batches={session.batches}
                      meetingDate={session.session_timestamp}
                      setIsOpen={() => setOpenSummaryModal(null)}
                    />
                  </TableCell>
                  <TableCell className="text-xs px-1 py-2 text-right">
                    <button
                      className="flex cursor-pointer items-center justify-center rounded-[4px] bg-white py-[5px] px-4 text-[12px] font-medium leading-[15px] text-[#646464] hover:bg-[#EBEBEB] border-[0.5px] border-[#d3d3d3] w-[85px] h-[25px]"
                      onClick={() => handleFeedbackClick(session.meeting_id)}
                    >
                      Feedback
                    </button>
                  </TableCell>
                  {isFeedbackCardOpen && studentFeedback ? (
                    <ProgressMeetFeedbackCard
                      isOpen={isFeedbackCardOpen === session.meeting_id}
                      feedbackData={studentFeedback}
                      setIsOpen={() => setIsFeedbackCardOpen(null)}
                    />
                  ) : (
                    <ProgressMeetFeedbackModal
                      isOpen={openFeedbackModal === session.meeting_id}
                      setIsOpen={() => setOpenFeedbackModal(null)}
                      chapterName={session.chapter_name}
                      saveFeedback={saveProgressMeetFeedback}
                      meetingId={session.meeting_id}
                    />
                  )}
                </TableRow>
              ))
          ) : (
            <TableRow className="px-4 hover:bg-[#ebebeb]">
              <TableCell colSpan={5} className="text-center py-4 text-gray-500">
                No data available
              </TableCell>
            </TableRow>
          )}
          <tr className="bg-[#F9F9F9]">
            <td className="py-[10px]"></td>
            <td className="py-[10px]"></td>
            <td className="py-[10px]"></td>
            <td className="py-[10px]"></td>
            <td className="py-[10px]"></td>
            <td className="py-[10px]"></td>
          </tr>
        </TableBody>
      </Table>
    </>
  )
}

export default PastSessionTable
